import { defineContent, type DefinedContent } from '@post-office/define-content';

// TODO: replace this placeholder copy once the final content is signed off.
export const messages: DefinedContent<
	['ctaTitle', 'ctaDescription', 'ctaLink', 'whyAmISeeingThisReason']
> = defineContent({
	default: {
		ctaTitle: {
			id: 'jsm-request-reolver-side-nav-banner.cta-title',
			defaultMessage: 'Speed up your work with Request Resolver',
			description: 'CTA title for the JSM request resolver side nav banner',
			role: 'title',
		},
		ctaDescription: {
			id: 'jsm-request-reolver-side-nav-banner.cta-description',
			defaultMessage:
				'Uses your internal knowledge to create resolution plans for your team to review and run.',
			description: 'CTA description for the JSM request resolver side nav banner',
			role: 'description',
		},
		ctaLink: {
			id: 'jsm-request-reolver-side-nav-banner.cta-link',
			defaultMessage: 'Explore',
			description: 'CTA link text for the JSM request resolver side nav banner',
		},
		whyAmISeeingThisReason: {
			id: 'jsm-request-reolver-side-nav-banner.why-am-i-seeing-this-reason',
			defaultMessage: 'You use Jira Service Management to handle customer requests',
			description: 'Reason for why the user is seeing the JSM request resolver side nav banner',
		},
	},
});
